<template>
  <Teleport to="body">
    <Transition name="app-sliding-panel">
      <div
        v-if="modelValue"
        class="app-sliding-panel"
        @mousedown.self="onBackdropClick">
        <div class="app-sliding-panel__container" :class="[positionClass, containerClass]">
          <slot />
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script setup>
import {
  computed, watch, onMounted, onBeforeUnmount
} from 'vue'

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false
  },
  position: {
    type: String,
    default: 'right',
    validator: (value) => ['left', 'right'].includes(value)
  },
  backdropClose: {
    type: Boolean,
    default: true
  },
  containerClass: {
    type: [String, Array, Object],
    default: null
  }
})

const emit = defineEmits(['update:modelValue'])

const positionClass = computed(() => `app-sliding-panel__container--${props.position}`)

const close = () => {
  emit('update:modelValue', false)
}

const onBackdropClick = () => {
  if (props.backdropClose) close()
}

const handleKeydown = (event) => {
  if (event.key === 'Escape' && props.modelValue) {
    close()
  }
}

watch(() => props.modelValue, (isOpen) => {
  document.body.classList.toggle('overflow-hidden', isOpen)
}, { immediate: true })

onMounted(() => {
  document.addEventListener('keydown', handleKeydown)
})

onBeforeUnmount(() => {
  document.removeEventListener('keydown', handleKeydown)
  document.body.classList.remove('overflow-hidden')
})

defineExpose({ close })
</script>
